import { ReactiveFormsModule } from '@angular/forms';
import { SendMessageComponent } from './components/send-message/send-message.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { EditorModule } from 'app/pages/A2-utils/editor/editor.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    Trip2ThemeModule,
    EditorModule
  ],
  declarations: [
    SendMessageComponent,
  ],
  exports: [
    SendMessageComponent,
  ]
})
export class SendMessageModule { }



// WEBPACK FOOTER //
// ./src/app/utils/send-message/send-message.module.ts